"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonChip = void 0;
var react_1 = __importDefault(require("react"));
var Avatar_1 = __importDefault(require("../Avatar"));
var HorizontalSpacer_1 = __importDefault(require("../../utils/HorizontalSpacer"));
var TextVerticalSpacer_1 = __importDefault(require("../../utils/TextVerticalSpacer"));
var PersonChipInfo_1 = __importDefault(require("./components/PersonChipInfo"));
var HORIZONTAL_SPACER = {
    '1': { small: 16, medium: 16, large: 16 },
    '2': { small: 12, medium: 12, large: 16 },
};
var AVATAR = {
    '1': { small: 48, medium: 56, large: 68 },
    '2': { small: 40, medium: 48, large: 56 },
};
var PersonChip = function (_a) {
    var name = _a.name, jobTitle = _a.jobTitle, image = _a.image, _b = _a.align, align = _b === void 0 ? 'center' : _b, _c = _a.level, level = _c === void 0 ? '1' : _c, children = _a.children, commonProps = __rest(_a, ["name", "jobTitle", "image", "align", "level", "children"]);
    return (react_1.default.createElement(HorizontalSpacer_1.default, __assign({ "data-component-name": "PersonChip" }, commonProps, { amount: HORIZONTAL_SPACER[level], align: align }),
        react_1.default.createElement("div", null,
            react_1.default.createElement(Avatar_1.default, { image: image, size: AVATAR[level] })),
        react_1.default.createElement(TextVerticalSpacer_1.default, { level: "5" },
            react_1.default.createElement(PersonChipInfo_1.default, { name: name, jobTitle: jobTitle, level: level }),
            children)));
};
exports.PersonChip = PersonChip;
exports.default = exports.PersonChip;
